import {
  GroupTypeUI
} from './../models/group-types.model';

export type GroupTypeState = GroupTypeUI[];

export const initialState: GroupTypeState = [] as GroupTypeState;
